import React, { useEffect } from 'react';
import './landingpage.css';
import SiteHeader from './SiteHeader';
import BlogFooter from './blog/BlogFooter';
import ContactForm from './ContactForm';
import ChecklistDownload from './blog/ChecklistDownload';
import { BROCHURE_PDF_URL, BROCHURE_PDF_FILE_NAME } from './Brochure';
import ScrollHelpers from './scrollHelper';
import { trackEvent } from './analytics';
import pc from './img/product/pc-dashboard.png';
import mobile from './img/product/mobile-site-home.png';
import hireDocs from './img/product/app-hire-docs.jpg';
import leaveSafe from './img/product/app-leave-safe.jpg';
import siren from './img/product/app-emergency-siren.jpg';
import riskSummary from './img/product/app-risk-constant-summary.jpg';
import riskHazards from './img/product/app-risk-constant-hazards.jpg';
import siteHome from './img/product/app-site-home.jpg';
import tbmQr from './img/product/app-tbm-qr.jpg';
import hqDashboard from './img/product/hq-dashboard.jpg';
import languageSettings from './img/product/mobile-language-settings.jpg';
import education from './img/phone_three3.png';
import hanshin from './img/br_05.png';
import dongwon from './img/br_12.png';
import hanyang from './img/br_06.png';
import sungdo from './img/br_09.png';
import kyungnam from './img/br_07.png';
import samwhan from './img/br_08.png';
import moa from './img/br_10.png';
import dongyang from './img/br_13.png';
import youngwoo from './img/br_04.png';
import nongsim from './img/br_02.png';
import komir from './img/br_11.png';
import woojin from './img/br_15.png';
import samchully from './img/br_16.png';
import hsad from './img/br_17.png';

const customers = [[hanshin, '한신공영'], [dongwon, '동원개발'], [hanyang, '한양'], [sungdo, '성도이엔지'], [kyungnam, '경남기업'], [samwhan, '삼환기업'], [moa, '모아종합건설'], [dongyang, '동양'], [youngwoo, '영무토건'], [nongsim, '농심엔지니어링'], [komir, '한국광해광업공단'], [woojin, '우진산전'], [samchully, '삼천리ES'], [hsad, 'HSAD']];
const manual = 'https://2-0-3.gitbook.io/tongpeoples_docs/';
const languages = ['한국어', '영어', '베트남어', '중국어', '러시아어', '우즈베크어', '태국어', '인도네시아어', '타갈로그어', '라오어', '힌디어', '몽골어', '미얀마어'];
const serviceScreens = [
  { name: '채용자 서류', caption: '서류 4종을 앱에서 작성하고 서명', image: hireDocs, width: 720, height: 1480 },
  { name: '퇴근 무사고', caption: '퇴근할 때 무사고 확인서에 서명', image: leaveSafe, width: 720, height: 1480 },
  { name: '위급사이렌', caption: '발동 전에 대피 집결 장소 확인', image: siren, width: 720, height: 1480 },
];
const services = [
  {
    id: 'attendance', name: '출퇴근 관리',
    description: '현장 가입부터 퇴근 무사고 확인까지, 날마다 출퇴근을 기록합니다.',
    features: ['링크 가입 · 현장 검색과 출근 신청', 'QR 출근 · 출근 승인과 반려', '퇴근 무사고 확인 · 사고 발생 시 관리자에게 전달'],
    guide: 'pc-2/level2-contractor-attendance',
  },
  {
    id: 'partners', name: '협력사·권한',
    description: '시공사와 협력사가 각자의 역할에 맞게 사람과 현장을 관리합니다.',
    features: ['협력사 등록 · 정보와 소속 근로자 관리', '관리자 등록 · 역할별 권한 설정', '개별 현장 관리 · 전체 현장 현황 조회'],
    guide: 'pc-2/level2-contractor-partner',
  },
  {
    id: 'safety', name: '안전문서',
    description: '작업 전 준비부터 교육과 회의 기록까지, 필요한 문서를 한곳에서 다룹니다.',
    features: ['위험성평가 · TBM · 안전교육', '작업계획서 · 위험성평가 회의록', '문서별 결재라인 · 결재 현황 · 엑셀 출력'],
    guide: 'pc-2/level2-approval-line-setup',
  },
  {
    id: 'documents', name: '근로자 서류',
    description: '근로자는 채용 서류를 앱에서 작성·서명해 제출하고, 관리자는 제출 현황과 필요한 서류를 확인합니다.',
    features: ['채용자 서류 앱 작성·서명 · 현장별 제출', '개인정보 동의서 · 안전관리 서약서 · 교육 이수·보호구 수령 확인서 · 건강문진표', '기초안전보건교육증 등록 · 제출 여부 조회 · 선택 다운로드'],
    guide: 'level3-worker-documents',
  },
  {
    id: 'communication', name: '현장 소통·의견',
    description: '공지는 빠르게 전하고, 근로자 의견은 조치 결과까지 기록합니다.',
    features: ['대상별 전달사항 · 현장공지 · 재해사례 공유', '종사자의견청취 · 위험·개선 의견 등록', '관리자의 조치 내용 · 사진 · 처리 현황'],
    guide: 'level3-worker-opinion',
  },
  {
    id: 'emergency', name: '비상 대응',
    description: '현장의 위급 상황을 알리고, 대피 완료 여부와 발동 이력을 확인합니다.',
    features: ['대피장소 · 사이렌 운영 설정', '모바일 위급사이렌 · 출근자 알림', '대피 완료·미대피 현황 · 발동 이력'],
    guide: 'level3-emergency-siren',
  },
];
const hqFeatures = [
  { name: '대시보드 · 현장 비교', description: '전체 현장을 함께 보거나 현장 하나를 골라, 기간별 출근과 안전 활동 현황을 나란히 봅니다.' },
  { name: '출퇴근 · 인력 현황', description: '현장별 출근·퇴근 인원과 협력사 가동 현황, 인력 구성을 확인합니다.' },
  { name: '안전 활동 현황', description: '위험성평가 · TBM · 작업계획서 · 종사자의견청취 기록을 현장별로 모아 봅니다.' },
  { name: '반기 점검 보고서', description: '경영책임자의 반기 점검에 맞춰 현장통에 쌓인 실적을 모아 보고, 점검 확인을 기록으로 남깁니다.' },
];
const steps = [
  { number: '01', name: '위험성평가', title: <>오늘 작업의 위험을<br />작업 전에 함께 확인합니다.</>, description: '작업에 맞는 위험성평가를 작성하고 결재를 진행합니다. 근로자가 모바일로 문서를 확인하면 관리자는 확인 현황을 볼 수 있습니다.', items: ['최초 · 정기 · 수시 · 상시 위험성평가', '위험요인·개선대책 · 근로자 확인 현황'], screens: [{ image: riskSummary, width: 720, height: 1480, alt: '상시 위험성평가 상세: 작업기간, 위험성 수준과 결재선' }, { image: riskHazards, width: 720, height: 1480, alt: '상시 위험성평가 상세: 위험요인, 개선대책과 확인 대상' }], caption: '모바일 위험성평가 · 상세', link: '/blog/risk-assessment-5steps' },
  { number: '02', name: 'TBM', title: <>아침 TBM도<br />빠짐없이 기록합니다.</>, description: '작업 내용과 안전대책을 작성하고, 수시·상시 위험성평가를 불러올 수 있습니다. 근로자가 QR을 보여 주면 관리자가 스캔해 참석을 등록합니다.', items: ['위험성평가 연계 · QR 참석 등록', 'TBM 결재 현황 · 엑셀 출력'], screens: [{ image: siteHome, width: 720, height: 1480, alt: '근로자 앱 현장 화면: 위험성평가, TBM, 퇴근 무사고 메뉴' }, { image: tbmQr, width: 720, height: 1480, alt: 'TBM·안전교육 QR 코드: 관리자가 스캔해 참석 등록' }], caption: '근로자 앱 · TBM·안전교육 QR', link: '/blog/tbm-no-record' },
  { number: '03', name: '안전교육', title: <>교육 내용과 참석자를<br />한 번에 관리합니다.</>, description: '교육 내용과 사진·자료를 등록하고 참석 명단을 확인합니다. 반복되는 교육은 이전 문서를 불러와 작성하고, 결재와 출력까지 이어가세요.', items: ['교육 기록 · QR 참석 등록', '기존 문서 불러오기 · 결재 · 엑셀 출력'], image: education, caption: '안전교육 등록 · 교육일지', link: '/blog/safety-manager-paperwork' },
];
const whyPosts = [
  { tag: '실무 가이드', title: '중대재해처벌법 건설사 실무 대응 가이드', text: '경영책임자 의무부터 판례와 면책 기준까지 정리했습니다.', href: '/blog/serious-accident-law' },
  { tag: '판례 비교', title: '면책된 회사와 안 된 회사, 딱 하나의 차이', text: '판례에서 확인되는 차이를 비교했습니다.', href: '/blog/exemption-one-difference' },
  { tag: '경영자', title: '사고 났을 때 대표이사가 처벌받는 조건 3가지', text: '기소된 사건에서 반복되는 조건을 정리했습니다.', href: '/blog/executive-punishment-conditions' },
];
const recordFlow = [
  ['01', '출근', 'QR 출퇴근과 근로자 서류 제출'],
  ['02', '작성 · 결재', '위험성평가 · 작업계획서 · 교육 문서와 결재라인'],
  ['03', '공유 · 확인', 'TBM · 교육 QR 참석 등록, 근로자 문서 확인'],
  ['04', '의견 · 조치', '종사자의견청취와 조치 내용 · 사진'],
  ['05', '기록 · 출력', '결재 현황과 엑셀 출력으로 다시 확인'],
];
const NEW_FEATURE_STATUS = '오픈 예정'; // 오픈 시 '신규'로 변경
const newFeatures = [
  { id: 'ai-risk', group: '위험성평가', name: 'AI 상시 위험성평가', description: '작업 정보를 바탕으로 AI가 위험요인과 감소대책 초안을 제안합니다. 관리자가 검토하고 확정합니다.' },
  { id: 'ai-education', group: '안전교육', name: 'AI 안전교육자료 생성', description: '현장 상황에 맞는 안전교육 자료 초안을 AI가 만들어 교육 준비를 돕습니다.' },
  { id: 'work-permit', group: '작업 허가', name: '작업허가서', description: '위험 작업의 허가 신청과 승인을 현장통에서 처리하고 기록으로 남깁니다.' },
  { id: 'inspection-log', group: '안전점검', name: '안전점검 일지', description: '점검 항목을 확인하고 결과를 일지로 남깁니다.' },
];
const checklists = [
  { title: '작업 전 TBM 기록 체크리스트', pdf: '/checklists/tbm-checklist.pdf', fileName: '현장통_작업전_TBM기록_체크리스트.pdf', post: '/blog/tbm-no-record' },
  { title: '위험성평가 6단계 체크리스트', pdf: '/checklists/risk-assessment-checklist.pdf', fileName: '현장통_위험성평가_6단계_체크리스트.pdf', post: '/blog/risk-assessment-5steps' },
  { title: '현장 일일 안전기록 체크리스트', pdf: '/checklists/daily-safety-record-checklist.pdf', fileName: '현장통_현장일일안전기록_체크리스트.pdf', post: '/blog/daily-record-3things' },
  { title: '장마철 건설현장 안전점검 체크리스트', pdf: '/checklists/rainy-season-safety-checklist.pdf', fileName: '현장통_장마철_건설현장_안전점검_체크리스트.pdf', post: '/blog/rainy-season-safety' },
];

function TrialLink({ location = 'body', children = '무료체험 문의', className = 'site-button' }) {
  return <a className={className} href="#contact" onClick={() => trackEvent('trial_cta_click', { location, page: '/' })}>{children}<span aria-hidden="true">↗</span></a>;
}

export default function LandingPage() {
  useEffect(() => {
    ScrollHelpers.scrollIntoView(document.getElementById(window.location.hash.slice(1)), null, 'auto');
  }, []);

  return (
    <div className="landing">
      <SiteHeader />
      <main>
        <section className="landing-hero" id="start" aria-labelledby="hero-title">
          <div className="landing-container hero-grid">
            <div className="hero-copy">
              <p className="landing-eyebrow"><span />시공사·협력사·근로자가 함께하는 현장관리</p>
              <h1 id="hero-title">출근부터 안전까지.<br />관리는 <em>한곳에서.</em></h1>
              <p className="hero-description">출퇴근과 근로자 서류부터 안전문서,<br />현장 공지와 비상 대응까지.<br className="desktop-break" /> 현장에서 하는 일을 현장통 하나로 관리하세요.</p>
              <div className="hero-actions"><TrialLink location="hero" /><a className="hero-phone" href="tel:0232722302" onClick={() => trackEvent('phone_click', { location: 'hero', page: '/' })}><span>전화 상담</span><strong>02-3272-2302</strong></a></div>
              <p className="hero-footnote">모바일·PC로 함께 관리 · 한국어 포함 13개 국어 지원</p>
            </div>
            <figure className="hero-product">
              <div className="product-label"><span /> 현장통 2.0 · PC와 모바일</div>
              <div className="product-screens">
                <img className="product-pc-screen" src={pc} width="1829" height="1102" alt="현장통 2.0 PC 관리자 대시보드: 현장 날씨, 미확인 문서와 출근자 현황" fetchpriority="high" />
                <div className="product-mobile"><img className="product-mobile-screen" src={mobile} width="720" height="2000" alt="현장통 2.0 모바일 시공사 관리자 내 현장: 출퇴근, 안전문서와 현장관리 메뉴" /></div>
              </div>
              <figcaption>PC 관리자 대시보드 · 모바일 내 현장</figcaption>
            </figure>
          </div>
          <div className="landing-container hero-scope"><p>매일 하는 현장 업무를<br /><strong>현장통 하나로.</strong></p><ul><li>출퇴근 관리</li><li>문서·안전</li><li>현장 소통</li><li>비상 대응</li></ul><a href="#functions" aria-label="현장통 서비스 전체 보기">서비스 전체 보기 <span aria-hidden="true">↓</span></a></div>
        </section>

        <section className="landing-why landing-section" id="why" aria-labelledby="why-title">
          <div className="landing-container">
            <div className="section-heading"><div><p className="landing-eyebrow">왜 기록인가</p><h2 id="why-title">안전관리는 매일 합니다.<br />남아 있어야 확인할 수 있습니다.</h2></div><p>중대재해처벌법은 경영책임자에게 안전보건 확보 의무의 이행을 요구합니다.<br />위험성평가·TBM·교육을 하고도 기록이 흩어져 있으면, 무엇을 했는지 다시 확인하기 어렵습니다.</p></div>
            <ul className="why-posts">
              {whyPosts.map(post => (
                <li key={post.href}><a href={post.href}><span className="why-tag">{post.tag}</span><h3>{post.title}</h3><p>{post.text}</p><span className="why-more">읽어보기 <span aria-hidden="true">↗</span></span></a></li>
              ))}
            </ul>
            <a className="landing-text-link" href="/blog">현장 실무 TIP 전체 보기 <span aria-hidden="true">↗</span></a>
            <h3 className="record-flow-title" id="record-flow-title">현장통에서는 이렇게 남습니다</h3>
            <ol className="record-flow" aria-labelledby="record-flow-title">
              {recordFlow.map(([number, name, text]) => <li key={number}><span>{number}</span><strong>{name}</strong><p>{text}</p></li>)}
            </ol>
          </div>
        </section>

        <section className="landing-services landing-section" id="functions" aria-labelledby="services-title">
          <div className="landing-container">
            <div className="section-heading">
              <div><p className="landing-eyebrow">현장통의 서비스</p><h2 id="services-title">출근부터 퇴근까지,<br />현장에서 하는 일을 함께 관리합니다.</h2></div>
              <p>사람과 서류, 안전과 소통.<br />현장에 필요한 업무를 살펴보세요.</p>
            </div>
            <ul className="service-list">
              {services.map((service, index) => (
                <li className="service-item" key={service.id}>
                  <p className="service-number" aria-hidden="true">0{index + 1}</p>
                  <h3>{service.name}</h3>
                  <p className="service-description">{service.description}</p>
                  <ul>{service.features.map(feature => <li key={feature}>{feature}</li>)}</ul>
                  <a className="landing-text-link" href={manual + service.guide} target="_blank" rel="noreferrer" onClick={() => trackEvent('service_guide_click', { service: service.id, page: '/' })}>
                    {service.name} 사용 안내 <span aria-hidden="true">↗</span>
                  </a>
                </li>
              ))}
            </ul>
            <div className="service-screen-heading"><h3>앱으로 하는 현장 업무</h3><p>화면을 누르면 크게 볼 수 있습니다.</p></div>
            <div className="service-screens">
              {serviceScreens.map(screen => (
                <figure key={screen.name}>
                  <a href={screen.image} target="_blank" rel="noreferrer" aria-label={`${screen.name} 화면 크게 보기 (새 창)`}>
                    <img src={screen.image} width={screen.width} height={screen.height} loading="lazy" alt={`현장통 ${screen.name}: ${screen.caption}`} />
                  </a>
                  <figcaption><strong>{screen.name}</strong><span>{screen.caption}</span></figcaption>
                </figure>
              ))}
            </div>
            <section className="service-language" aria-labelledby="language-title">
              <div>
                <p className="landing-eyebrow">한국어 포함 13개 국어 지원</p>
                <h3 id="language-title">익숙한 언어로,<br />현장의 소통을 함께.</h3>
                <p>현장통 앱에서 사용할 언어를 선택하세요.</p>
                <ul>{languages.map(language => <li key={language}>{language}</li>)}</ul>
                <p className="language-translate">위험성평가 · TBM · 작업계획서 화면에서 <strong>번역 아이콘</strong>을 누르면 내용을 근로자의 언어로 볼 수 있습니다.</p>
                <p className="language-note">자동 번역입니다. 관리자 PC 화면과 상시 위험성평가 · 전달사항 내용은 한국어로 표시됩니다.</p>
                <a className="landing-text-link" href={manual + 'level3-foreign-workers'} target="_blank" rel="noreferrer" onClick={() => trackEvent('service_guide_click', { service: 'foreign_workers', page: '/' })}>외국인 근로자 지원 안내 <span aria-hidden="true">↗</span></a>
              </div>
              <figure>
                <a href={languageSettings} target="_blank" rel="noreferrer" aria-label="10개 국어 언어 설정 화면 크게 보기 (새 창)">
                  <img src={languageSettings} width="1080" height="2340" loading="lazy" alt="현장통 앱 언어 설정: 한국어부터 라오어까지 10개 언어 선택" />
                </a>
                <figcaption>앱 언어 설정 화면</figcaption>
              </figure>
            </section>
          </div>
        </section>

        <section className="landing-new landing-section" id="new-features" aria-labelledby="new-title">
          <div className="landing-container">
            <div className="section-heading"><div><p className="landing-eyebrow">NEW · 새 기능 오픈 예정</p><h2 id="new-title">작성은 더 가볍게,<br />현장 통제는 더 촘촘하게.</h2></div><p>현장통에 새 기능이 더해집니다.<br />세부 내용과 오픈 일정은 상담으로 안내해 드립니다.</p></div>
            <ul className="new-list">
              {newFeatures.map(feature => (
                <li className="new-item" key={feature.id}>
                  <p className="new-badges"><span>NEW</span><span>{NEW_FEATURE_STATUS}</span></p>
                  <p className="new-group">{feature.group}</p>
                  <h3>{feature.name}</h3>
                  <p className="new-description">{feature.description}</p>
                </li>
              ))}
            </ul>
            <TrialLink location="new_features">새 기능 도입 문의</TrialLink>
          </div>
        </section>

        <section className="landing-workflow landing-section" id="workflow" aria-labelledby="workflow-title">
          <div className="landing-container">
            <div className="section-heading"><div><p className="landing-eyebrow">실제 사용 흐름 · 안전업무 예시</p><h2 id="workflow-title">작성하고, 함께 확인하고,<br />기록으로 남깁니다.</h2></div><p>위험성평가 · TBM · 안전교육이<br />현장통에서 이어지는 방식입니다.</p></div>
            <ol className="workflow-list">
              {steps.map(step => (
                <li className="workflow-step" key={step.number}>
                  <div className="workflow-copy">
                    <p className="workflow-label"><span>{step.number}</span>{step.name}</p>
                    <h3>{step.title}</h3><p>{step.description}</p>
                    <ul>{step.items.map(item => <li key={item}>{item}</li>)}</ul>
                    <a className="landing-text-link" href={step.link}>{step.name} 실무 TIP <span aria-hidden="true">↗</span></a>
                  </div>
                  <figure className="workflow-image">
                    {step.screens ? (
                      <div className="workflow-screens">
                        {step.screens.map(screen => (
                          <a key={screen.image} href={screen.image} target="_blank" rel="noreferrer" aria-label={`${screen.alt} 크게 보기 (새 창)`}>
                            <img src={screen.image} width={screen.width} height={screen.height} loading="lazy" alt={screen.alt} />
                          </a>
                        ))}
                      </div>
                    ) : <img src={step.image} width="789" height="506" loading="lazy" alt={`현장통 ${step.caption} 화면 예시`} />}
                    <figcaption>{step.caption}</figcaption>
                  </figure>
                </li>
              ))}
            </ol>
            <div className="people-flow"><p>같은 현장에서<br /><strong>각자의 역할에 맞게</strong></p><ol><li><strong>근로자</strong><span>출근 · 서류 제출 · 의견</span></li><li><strong>협력사</strong><span>소속 인원 · 문서 관리</span></li><li><strong>시공사·본사</strong><span>전 현장 현황 · 반기 점검</span></li></ol></div>
          </div>
        </section>

        <section className="landing-hq landing-section" id="hq" aria-labelledby="hq-title">
          <div className="landing-container">
            <div className="section-heading"><div><p className="landing-eyebrow">본사시스템</p><h2 id="hq-title">모든 현장을,<br />본사에서 한 화면으로.</h2></div><p>시공사 본사 안전관리자는 전 현장의 출퇴근과 안전 활동 기록을 한곳에서 확인합니다.<br />문서 작성과 결재는 각 현장에서 그대로 진행합니다.</p></div>
            <figure className="hq-screen">
              <a href={hqDashboard} target="_blank" rel="noreferrer" aria-label="본사시스템 대시보드 화면 크게 보기 (새 창)">
                <img src={hqDashboard} width="1600" height="1118" loading="lazy" alt="본사시스템 대시보드: 전체 현장 출근, 무사고율, 위험성평가와 현장별 출근 인원" />
              </a>
              <figcaption>본사시스템 대시보드 · 예시 데이터</figcaption>
            </figure>
            <ul className="hq-list">
              {hqFeatures.map((feature, index) => (
                <li className="hq-item" key={feature.name}>
                  <p className="hq-number" aria-hidden="true">0{index + 1}</p>
                  <h3>{feature.name}</h3>
                  <p className="hq-description">{feature.description}</p>
                </li>
              ))}
            </ul>
            <p className="hq-note">보고서는 현장통에 기록된 활동을 모아 보여 주는 자료이며, 법령 이행 여부를 판단하거나 보장하지 않습니다. 본사시스템은 본사 접근 권한을 받은 관리자가 이용합니다.</p>
            <a className="landing-text-link" href={manual + 'undefined/hq-index'} target="_blank" rel="noreferrer" onClick={() => trackEvent('service_guide_click', { service: 'hq', page: '/' })}>본사시스템 사용 안내 <span aria-hidden="true">↗</span></a>
          </div>
        </section>

        <section className="landing-proof landing-section" id="proof" aria-labelledby="proof-title">
          <div className="landing-container"><div className="section-heading"><div><p className="landing-eyebrow">도입 근거</p><h2 id="proof-title">이미 많은 현장이<br />현장통을 쓰고 있습니다.</h2></div><p>현장통에 등록된 근로자 수와,<br />위험성평가 작성에 쓰는 공종별 데이터입니다.</p></div><dl className="proof-stats"><div><dt>현장통 등록 근로자</dt><dd>40,000<span>명 이상</span></dd><dd className="proof-caption">현장통에 등록된 근로자 규모</dd></div><div><dt>위험요인 · 개선대책 데이터</dt><dd>23,000<span>여 개</span></dd><dd className="proof-caption">위험성평가 작성에 활용하는 공종별 데이터</dd></div></dl><div className="customer-heading"><h3>현장통과 함께하는 건설사 · 기관</h3></div><ul className="customer-logos">{customers.map(([src, name]) => <li key={name}><img src={src} alt={name} loading="lazy" /></li>)}</ul></div>
        </section>

        <section className="landing-resources landing-section" id="resources" aria-labelledby="resources-title">
          <div className="landing-container">
            <div className="section-heading"><div><p className="landing-eyebrow">자료실</p><h2 id="resources-title">바로 쓰는 안전 서식.</h2></div><p>박람회 브로슈어와 현장에서 바로 확인할 수 있는 체크리스트를 무료로 받아보세요.</p></div>
            <ul className="resource-list">
              <li className="resource-item resource-item-featured">
                <span className="resource-tag">브로슈어</span>
                <h3>현장통 소개 브로슈어 (8페이지)</h3>
                <span className="resource-format">PDF</span>
                <a className="resource-post" href="/brochure" onClick={() => trackEvent('brochure_open_click', { location: 'resources', page: '/' })}>모바일로 보기 <span aria-hidden="true">↗</span></a>
                <a className="resource-download" href={BROCHURE_PDF_URL} download={BROCHURE_PDF_FILE_NAME} onClick={() => trackEvent('brochure_pdf_download', { location: 'resources', page: '/' })}>PDF 받기 ↓</a>
              </li>
              {checklists.map(item => (
                <li className="resource-item" key={item.pdf}>
                  <span className="resource-tag">체크리스트</span>
                  <h3>{item.title}</h3>
                  <span className="resource-format">PDF</span>
                  <a className="resource-post" href={item.post}>관련 글 <span aria-hidden="true">↗</span></a>
                  <ChecklistDownload checklistTitle={item.title} pdf={item.pdf} fileName={item.fileName} className="resource-download" label="무료로 받기 ↓" />
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="landing-trial landing-section" id="intro" aria-labelledby="trial-title">
          <div className="landing-container"><div className="section-heading"><div><p className="landing-eyebrow">도입 절차</p><h2 id="trial-title">우리 현장에 맞는지,<br />직접 확인해 보세요.</h2></div><div><p>현장의 업무와 운영 방식에 맞춰<br />무료체험과 도입 방법을 안내해 드립니다.</p><TrialLink /></div></div><ol className="trial-steps">{[['상담 신청', '연락처와 궁금한 점을 남겨주세요.'], ['이용 안내', '현장에 필요한 기능과 사용 방법을 확인합니다.'], ['체험', '실제 업무 흐름에 맞춰 살펴보세요.'], ['도입 검토', '현장에 맞는 운영 방법을 상담합니다.']].map(([title, text], index) => <li key={title}><span>0{index + 1}</span><h3>{title}</h3><p>{text}</p></li>)}</ol><div className="trial-support"><div><p className="landing-eyebrow">자주 묻는 질문</p><h3>도입 전에 많이 묻는 질문입니다.</h3><p>더 자세한 내용은 상담으로 안내해 드립니다.</p></div><div className="faq-list"><details className="landing-details"><summary>모바일과 PC에서 모두 사용할 수 있나요?</summary><p>근로자는 모바일 앱에서 출퇴근, 서류 제출과 안전 활동에 참여합니다. 시공사·협력사 관리자는 PC에서 문서 작성·결재와 인원·서류를 관리하고, 현장에서는 모바일로 참석을 확인하고 의견과 비상 상황에 대응합니다.</p></details><details className="landing-details"><summary>외국인 근로자도 사용할 수 있나요?</summary><p>근로자 앱은 한국어를 포함해 13개 언어를 지원합니다. 위험성평가 · TBM · 작업계획서 내용은 번역 아이콘으로 근로자의 언어로 볼 수 있습니다. 자동 번역이므로 중요한 내용은 현장에서 한 번 더 안내해 주세요.</p></details><details className="landing-details"><summary>본사에서 여러 현장을 한 번에 볼 수 있나요?</summary><p>본사시스템에서 전 현장의 출퇴근과 위험성평가 · TBM · 작업계획서 · 종사자의견청취 현황을 기간별로 확인할 수 있습니다. 이용 권한과 도입 방법은 상담으로 안내해 드립니다.</p></details><details className="landing-details"><summary>무료체험은 어떻게 문의하나요?</summary><p>아래 상담 폼을 작성하거나 02-3272-2302로 전화해주세요. 현장에 필요한 기능과 체험 진행 방법을 안내해 드립니다.</p></details><details className="landing-details" id="downloads"><summary>이미 이용 중입니다. 어디서 접속하나요?</summary><p>PC 서비스에 접속하거나 사용 중인 기기에 맞는 앱을 다운로드하세요.</p><div className="download-links"><a href={manual} target="_blank" rel="noreferrer">사용설명서 ↗</a><a href="https://www.tongpeoples.com/" target="_blank" rel="noreferrer">PC 서비스 ↗</a><a href="https://play.google.com/store/apps/details?id=com.tongpeoples.user" target="_blank" rel="noreferrer">Google Play ↗</a><a href="https://apps.apple.com/kr/app/%ED%98%84%EC%9E%A5%ED%86%B52-0/id6480398386" target="_blank" rel="noreferrer">App Store ↗</a><a href="https://cdn.hongtong.kr/public-production-apk/HongTong-v1.3.3-prod-release.zip">APK 다운로드 ↓</a></div></details></div></div></div>
        </section>

        <section className="landing-cta-band" aria-labelledby="cta-band-title">
          <div className="landing-container cta-band-inner">
            <div><h2 id="cta-band-title">우리 현장의 기록,<br />지금 어떻게 남고 있나요?</h2><p>무료체험과 도입 방법을 현장에 맞춰 안내해 드립니다.</p></div>
            <div className="cta-band-actions"><TrialLink location="cta_band" /><a className="cta-band-phone" href="tel:0232722302" onClick={() => trackEvent('phone_click', { location: 'cta_band', page: '/' })}>전화 상담 02-3272-2302</a></div>
          </div>
        </section>

        <section className="landing-contact landing-section" id="contact" aria-labelledby="contact-title"><div className="landing-container contact-grid"><div className="contact-copy"><p className="landing-eyebrow">상담 문의</p><h2 id="contact-title">우리 현장에 맞는 방법,<br />상담으로 찾아 드립니다.</h2><p>무료체험부터 도입 상담까지.<br />궁금한 점을 남겨 주시면 확인 후 연락드립니다.</p><a className="contact-direct" href="tel:0232722302" onClick={() => trackEvent('phone_click', { location: 'body', page: '/' })}><span>전화로 바로 문의하기 ↗</span><strong>02-3272-2302</strong></a><div className="contact-signature"><span>현장통</span><p>출근부터 안전까지. 관리는 한곳에서.</p></div></div><ContactForm /></div></section>

        <section className="landing-company" id="vision" aria-labelledby="company-title"><div className="landing-container company-grid"><div><p className="landing-eyebrow">회사 소개</p><h2 id="company-title">사람과 소통에 집중합니다.</h2><p>통하는사람들은 사람과 사람이 통하는, 안전한 현장을 만들고자 설립했습니다.</p></div><div><details className="landing-details" id="history"><summary>통하는사람들이 걸어온 길</summary><ul className="company-history"><li><time>2023.12</time>디캠프 프론트원 입주기업 선정</li><li><time>2023.11</time>벤처기업 등록</li><li><time>2023.09</time>연구전담부서 설립</li><li><time>2023.08</time>wateRound 2기 플랫폼 협약파트너사 · 신용보증기금 NEST 14기 선정</li><li><time>2023.06</time>스마트건설 얼라이언스 협회 가입</li><li><time>2023.05</time>DB손해보험 스타트업 오픈스테이지 밋업 선정 · 한국스마트건설안전협회 가입</li><li><time>2023.04</time>울산경제혁신센터 예비창업패키지 선정</li><li><time>2023.03</time>통하는사람들 신규 합작법인 설립</li></ul></details><details className="landing-details"><summary>현장통 소개 영상 보기</summary><iframe className="company-video" src="https://www.youtube.com/embed/OfD3zoHt3Ow" title="현장통 서비스 소개 영상" loading="lazy" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></details><a className="landing-text-link" href="/blog">현장 실무 TIP 읽기 <span aria-hidden="true">↗</span></a></div></div></section>
      </main>
      <BlogFooter />
    </div>
  );
}
